<template>
  <div class="wish-also" @click.stop>
    <span
      v-for="n in tagged"
      :key="n"
      class="wish-also-pill"
      :title="'Also tagged: ' + n"
    >
      {{ n }}
      <button
        v-if="editable"
        type="button"
        class="wish-also-x"
        :aria-label="'Remove ' + n"
        @click="$emit('remove', n)"
      >×</button>
    </span>
    <select
      v-if="editable && addable.length"
      class="wish-also-add"
      :value="''"
      @change="onAdd"
    >
      <option value="">+ also</option>
      <option v-for="n in addable" :key="n" :value="n">{{ n }}</option>
    </select>
  </div>
</template>

<script>
export default {
  name: 'WishAlsoTagged',
  props: {
    tagged: { type: Array, default: () => [] },
    assignedTo: { type: String, default: '' },
    teamNames: { type: Array, default: () => [] },
    editable: { type: Boolean, default: true }
  },
  emits: ['add', 'remove'],
  computed: {
    addable() {
      const taken = new Set(
        [...(this.tagged || []), this.assignedTo].map((n) => (n || '').toString().trim()).filter(Boolean)
      )
      return (this.teamNames || []).filter((n) => !taken.has(n))
    }
  },
  methods: {
    onAdd(e) {
      const name = (e.target.value || '').trim()
      e.target.value = ''
      if (name) this.$emit('add', name)
    }
  }
}
</script>

<style scoped>
.wish-also {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.28rem;
  margin-top: 0.28rem;
}
.wish-also-pill {
  display: inline-flex;
  align-items: center;
  gap: 0.15rem;
  padding: 0.12rem 0.45rem;
  border-radius: 999px;
  font-size: 0.72rem;
  font-weight: 600;
  color: #ecfffa;
  background: rgba(26, 188, 156, 0.22);
  border: 1px solid rgba(167, 243, 208, 0.28);
}
.wish-also-x {
  border: none;
  background: transparent;
  color: inherit;
  cursor: pointer;
  padding: 0 0.05rem;
  font-size: 0.85rem;
  line-height: 1;
  opacity: 0.75;
}
.wish-also-x:hover { opacity: 1; }
.wish-also-add {
  border: 1px solid rgba(255, 255, 255, 0.18);
  background: rgba(0, 0, 0, 0.28);
  color: rgba(255, 255, 255, 0.75);
  border-radius: 999px;
  padding: 0.1rem 0.4rem;
  font-size: 0.72rem;
  font-weight: 600;
  cursor: pointer;
}
</style>
